import Vue from 'vue'
import Router from 'vue-router'

// import Index from '@/views/index/Index'
import ReportOnline from '@/views/ReportOnline'
import ReportContent from '@/views/ReportContent'
// 网约车花小猪使用
import PigReportContent from '@/views/PigReportContent.vue'
import DiscreditInquiry from '@/views/DiscreditInquiry'
import ArticleDetail from '@/views/ArticleDetail'
import FAQ from '@/views/FAQ'
import News from '@/views/News'
import RiskManage from '@/views/RiskManage'
import Industry from '@/views/Industry'
import Rules from '@/views/Rules'
import Notice from '@/views/Notice'
import Error from '@/views/Error'
Vue.use(Router)
const basePath = require('../../config/basePath')
const router = new Router({
  base: `/${basePath}/`,
  mode: 'history',
  routes: [
    // {
    //   path: '/',
    //   name: 'Index',
    //   component: Index
    // },
    {
      path: '*',
      redirect: '/error'
    },
    {
      path: '/error',
      name: 'error',
      component: Error
    },
    {
      path: '/reportOnline',
      name: 'reportOnline',
      component: ReportOnline
    },
    {
      path: '/reportContent',
      name: 'reportContent',
      component: ReportContent
    },
    {
      path: '/discreditInquiry',
      name: 'discreditInquiry',
      component: DiscreditInquiry
    },
    {
      path: '/articleDetail',
      name: 'articleDetail',
      component: ArticleDetail
    },
    {
      path: '/FAQ',
      name: 'FAQ',
      component: FAQ
    },
    {
      path: '/news',
      name: 'news',
      component: News
    },
    {
      path: '/riskManage',
      name: 'riskManage',
      component: RiskManage
    },
    {
      path: '/industry',
      name: 'industry',
      component: Industry
    },
    {
      path: '/rules',
      name: 'rules',
      component: Rules
    },
    {
      path: '/notice',
      name: 'notice',
      component: Notice
    },
    {
      path: '/pigReportContent',
      name: 'pigReportContent',
      component: PigReportContent
    }
  ],
  scrollBehavior (to, from, savedPosition) {
	if (savedPosition) {
	  return savedPosition;
	} else {
	  return { x: 0, y: 0 }
	}
  }
})
router.beforeEach((to, from, next) => {
  let isExternalName = to.query.isExternalName
  if (isExternalName) {
    document.getElementsByTagName("title")[0].innerText = isExternalName
  }
  next()
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js